import React, { useEffect, useRef } from 'react';
import STYLES from 'src/utils/stylesConstants';
import ReadMoreLess from '../ReadMoreLess';
import styles from './DetailsInfo.module.scss';
import { filterAuctionDetailsForPastAuction } from 'shared/helpers/auctions';
import { setupCatalogueLinkTracking } from 'utils/analytics';

const DetailsInfo = ({
  info,
  cutAfter,
  maxHeight,
  isPastAuction,
  auctionName,
}) => {
  const filteredInfo = filterAuctionDetailsForPastAuction(info, isPastAuction);
  const containerRef = useRef(null);

  useEffect(() => {
    const cleanup = setupCatalogueLinkTracking(containerRef, auctionName);
    return cleanup;
  }, [filteredInfo, auctionName]);

  const renderStepDesc = (content, style) => {
    switch (style) {
      case STYLES.readMoreLess:
        return (
          <div className={styles.viewingText}>
            <ReadMoreLess
              cutAfter={cutAfter}
              content={content || ''}
              isMarkdown={true}
              maxHeight={maxHeight}
              withShadow={false}
            />
          </div>
        );
      default:
        return (
          <div
            className={styles.viewingText}
            dangerouslySetInnerHTML={{
              __html: content || '',
            }}
          />
        );
    }
  };

  return filteredInfo?.length ? (
    <div className={styles.detailsInfoWrapper} ref={containerRef}>
      <div className={styles.waysText}>
        <div>
          {filteredInfo.map((row, index) => (
            <div
              className={`${styles.infoGrid} ${
                row.headline.toLowerCase().includes('viewing')
                  ? styles.viewingSection
                  : ''
              }`}
              key={`vehicleSaleStep${index}`}
            >
              <div className={styles.leftSection}>
                <div
                  style={{ backgroundImage: `url(${row?.icon?.file?.url})` }}
                  className={styles.img}
                />
                <h3>{row.headline}</h3>
              </div>
              <div className={styles.rightSection}>
                {renderStepDesc(
                  row?.paragraph?.childMarkdownRemark?.html,
                  row?.style
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  ) : null;
};

export default DetailsInfo;
